import ReportProblem from './report-problem';

export default ReportProblem;
